import React from 'react'
import { BiLogoLinkedin } from 'react-icons/bi'

import mentor1 from './image/mentor1.jpg'
import mentor2 from './image/mentor2.jpeg'
import mentor3 from './image/mentor3.jpg'
import mentor4 from './image/mentor4.jpg'

const mentors = [
  // {
  //   name: 'Ayan Kumar Ghosh',
  //   expertise: 'AI, ML/Expert',
  //   image: mentor1,
  //   linkedin:
  //     'https://www.linkedin.com/in/akghsh?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
  //   alt: 'Ayan Kumar Ghosh',
  // },
  // {
  //   name: 'Mukesh Joshi',
  //   expertise: 'Web Development/Expert',
  //   image: mentor3,
  //   linkedin:
  //     'https://www.linkedin.com/in/mukesh-joshi-87444b163?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
  //   alt: 'Mukesh Joshi',
  // },
  // {
  //   name: 'Aman Gupta',
  //   expertise: 'Cyber Security/Cloud Computing',
  //   image: mentor4,
  //   linkedin:
  //     'https://www.linkedin.com/in/amanguptaiam?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
  //   alt: 'Aman Gupta',
  // },
]

function All_Program_Mentor() {
  return (
    <>
      <style>{`
       .Mentor_component_text{
          color: #2b1c50;
          font-family: 'Poppins', sans-serif;
          user-select: none;
        }
        .Mentor_card_img{
          width:50%;
        }
        .Mentor_component_text_main h1{
          color: #2b1c50;
          font-family: 'Poppins', sans-serif;
          user-select: none;
        }
       .Mentor_component_text_main h2{
          color: #2b1c50;
          font-family: 'Poppins', sans-serif;
          user-select: none;
        }

        .Mentor_component_text_main p{
          color: var(--color-grey-darken-2);
          font-family: 'Poppins', sans-serif;
          font-weight:500;
          list-style:none;
          font-size:0.9rem;
          user-select: none;
        }
        .Mentor_name_text h4{
          color: #2b1c50;
          font-weight: 600;
          font-size:1.1rem;
          user-select: none;
        }
        .Mentor_name_text p{
          font-size:0.8rem;
          color: var(--color-grey-darken-2);
          font-family: 'Poppins', sans-serif;
          user-select: none;
        }
      `}</style>
      {/* <div>
        <div className="">
          <div className="bg-white">
            <div className="container py-4">
              <div className="text-center Mentor_component_text_main">
                <h2 className="display-6">Meet Our Mentors</h2>
                <p className="py-2">
                  A luminary for your success: meet the outstanding mentors who
                  will encourage, uplift, and advance you towards achievement.
                </p>
              </div>
              <div className="row justify-content-center">
                {mentors.map((mentor, index) => (
                  <div className="col-md-3 col-6" key={index}>
                    <div className="py-3">
                      <div className="d-flex justify-content-center mb-4">
                        <img
                          src={mentor.image}
                          className="rounded-circle shadow-1-strong Mentor_card_img"
                          alt={mentor.name}
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                      <div className="text-center Mentor_name_text">
                        <h4 className="mb-2">{mentor.name}</h4>
                        <p className="mb-2">
                          {mentor.expertise.split('/').map((line) => (
                            <>
                              {line}
                              <br />
                            </>
                          ))}
                        </p>
                      </div>
                      <div className="d-flex justify-content-center">
                        <div className="text-center pt-2">
                          <a
                            href={mentor.linkedin}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <BiLogoLinkedin
                              size="40px"
                              color="#3d2e7c"
                              className="border rounded-pill p-2"
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  )
}

export default All_Program_Mentor
